import React from 'react'
import IntershipSalesforce from '../Internships/components/IntershipSalesforce'

const Saleforce = () => {
  return (
    <>
      <div className='container my-5 enroll'>
        <div className='row py-5  '>

          <div className=" col-md-6 ">
            <div className='mt-5 px-5 me-3'>
              <div className="">
                <h3 className="course-heading  " >Sales Force</h3>
                <p className="text-justify ">
                  Salesforce is a powerful cloud-based CRM platform that allows businesses to manage
                  customer data, sales processes, marketing automation, and more. This roadmap is
                  designed to take you from a complete beginner to an advanced Salesforce user, covering
                  Administration, Development (Apex & Lightning), and Integration. By the end of the six
                  months, you’ll be equipped with the knowledge and practical experience needed for a
                  Salesforce certification and job opportunities.

                </p>

              </div>
            </div>
          </div>
          <div className=' col-md-6  ' >
            <div className='mt-2'>
              <img className="img-fluid mx-auto d-flex" width="100%" src={require('../../assets/images/Hire-our-Wordpress-Developer.png')} /> </div>
          </div>
        </div>
      </div>
      <IntershipSalesforce />
    </>
  )
}

export default Saleforce